import $ from 'jquery';
const artikkel = $(".wp-block-straightdeal-artikkel-archive");

export const componentList = [ 
  {
    element: artikkel,
    functionName: "universal_filter",
    mobile: true,
  }
];
